<template>
  <a-form :form="form.fc" v-bind="formItemLayout">
    <a-form-item :label="$t('scope.text_21')">
      <a-input v-decorator="decorators.name" :placeholder="$t('scope.text_38')" />
    </a-form-item>
    <a-form-item :label="$t('scope.text_54')">
      <a-input v-decorator="decorators.description" :placeholder="$t('scope.text_55')" />
    </a-form-item>
  </a-form>
</template>

<script>
export default {
  name: 'GuideRegionCreate',
  // inject: ['formItemLayout'],
  data () {
    return {
      loading: false,
      region: {},
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          md: { span: 10 },
        },
        labelCol: {
          md: { span: 2 },
        },
      },
      decorators: {
        name: [
          'name',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_56') },
            ],
          },
        ],
        description: [
          'description',
          {
            rules: [
              { max: 600, message: this.$t('scope.text_57') },
            ],
          },
        ],
      },
    }
  },
  created () {
    this.manager = new this.$Manager('cloudregions')
    this.fetchRegion()
  },
  methods: {
    async fetchRegion () {
      try {
        const { data = {} } = await this.manager.list({
          params: {
            id: 'default',
          },
        })
        const list = (data.data || [])
        if (list.length > 0) {
          const item = list[0]
          this.region = item
          this.form.fc.setFieldsValue({
            name: item.name,
            description: item.description,
          })
        }
      } catch (error) {
        throw error
      }
    },
    async doSubmit () {
      try {
        const values = await this.form.fc.validateFields()
        const { data } = await this.manager.update({
          id: this.region.id,
          data: values,
        })
        return ['region', data]
      } catch (err) {
        throw err
      }
    },
  },
}
</script>
